import { jwtDecode } from "jwt-decode";
import { IdyaJwtPayload } from "../types/JwtPayload";

export const jwtHelper = {
  isTokenValid(
    token: string | null,
    getDecodedToken: (token: IdyaJwtPayload) => void
  ): boolean {
    if (!token) return false;
    try {
      const decodedToken = jwtDecode<IdyaJwtPayload>(token);

      // Token süresinin dolup dolmadığını kontrol edelim
      const now = Date.now() / 1000;
      if (decodedToken.exp && decodedToken.exp <= now) {
        return false; // Token süresi dolmuş
      }
      // Issuer ve Audience kontrolü
      if (
        decodedToken.iss !== process.env.REACT_APP_ISSUER ||
        decodedToken.aud !== process.env.REACT_APP_Audience
      ) {
        return false; // Token'daki issuer veya audience beklenenden farklı
      }

      getDecodedToken(decodedToken);
      return true; // Token geçerli ve issuer ile audience doğru
    } catch (error) {
      return false; // Token geçersiz veya decode edilemedi
    }
  },
};
